module.exports = __webpack_public_path__ + "static/media/phone.35c2ddd5.svg";